import Vue from 'vue';
import {
  ModalPlugin,
  FormPlugin,
  DropdownPlugin,
  PaginationPlugin,
  ButtonPlugin,
  FormGroupPlugin,
  TooltipPlugin,
  BFormCheckbox,
  BLink,
  BSpinner,
  BInputGroup,
  BFormInput,
  BFormSelect,
  BInputGroupAppend,
  BInputGroupAddon,
  BImg,
  BIcon,
  BFormRadioGroup,
  BCollapse
} from 'bootstrap-vue';

Vue.use(ModalPlugin);
Vue.use(FormPlugin);
Vue.use(FormGroupPlugin);
Vue.use(DropdownPlugin);
Vue.use(PaginationPlugin);
Vue.use(ButtonPlugin);
Vue.use(TooltipPlugin);
Vue.component('b-form-checkbox', BFormCheckbox);
Vue.component('b-form-input', BFormInput);
Vue.component('b-form-select', BFormSelect);
Vue.component('b-form-radio-group', BFormRadioGroup);
Vue.component('b-link', BLink);
Vue.component('b-spinner', BSpinner);
Vue.component('b-input-group', BInputGroup);
Vue.component('b-input-group-append', BInputGroupAppend);
Vue.component('b-input-group-addon', BInputGroupAddon);
Vue.component('b-img', BImg);
Vue.component('b-icon', BIcon);
Vue.component('b-collapse', BCollapse);
